export default [
  {
    additionalAttributes: {
      city: 'São Paulo',
      country: 'Brasil',
      description:
        'Sou Matheus, desenvolvedor focado em criar soluções web inovadoras. Atualmente, trabalho como Desenvolvedor de Produto na Responza.',
      companyName: 'Responza',
      countryCode: 'BR',
      socialProfiles: {
        github: 'matheus-duarte',
        twitter: 'matheus_dev_br',
        facebook: 'matheus.duarte',
        linkedin: 'matheus-ginez-duarte',
        instagram: 'matheus.codes',
      },
    },
    availabilityStatus: 'offline',
    email: 'matheus.duarte@responza.com.br',
    id: 22,
    name: 'Matheus Ginez Duarte',
    phoneNumber: '+5511987654321',
    identifier: null,
    thumbnail: '',
    customAttributes: {
      dateContact: '2024-11-11T11:53:09.299Z',
      linkContact: 'https://example.com',
      listContact: 'Acompanhamento',
      textContact: 'Olá, tudo bem?',
      numberContact: '42',
      checkboxContact: false,
    },
    lastActivityAt: 1712123233,
    createdAt: 1712123233,
  },
  {
    additionalAttributes: {
      city: 'Rio de Janeiro',
      country: 'Brasil',
      description: 'Apaixonado por desenvolvimento full-stack e soluções escaláveis.',
      companyName: 'Tech Solutions',
      countryCode: 'BR',
      socialProfiles: {
        github: 'igor-sakaguchi',
        twitter: 'igor_dev',
        facebook: 'igor.sakaguchi',
        linkedin: 'igor-kendy-sakaguchi',
        instagram: 'igor.tech',
      },
    },
    availabilityStatus: 'offline',
    email: 'igor.sakaguchi@responza.com.br',
    id: 21,
    name: 'Igor Kendy Sakaguchi',
    phoneNumber: '+5521987654322',
    identifier: null,
    thumbnail: '',
    customAttributes: {
      dateContact: '2024-10-05T10:12:34.567Z',
      linkContact: 'https://designbrasil.com',
      listContact: 'Prospectos',
      textContact: 'Ansiosa para nos conectarmos!',
    },
    lastActivityAt: 1712123233,
    createdAt: 1712123233,
  },
  {
    additionalAttributes: {
      city: 'Belo Horizonte',
      country: 'Brasil',
      description: 'Especialista em arquitetura de software e desenvolvimento ágil.',
      companyName: 'TechHub Brasil',
      countryCode: 'BR',
      socialProfiles: {
        github: 'davi-garcez',
        twitter: 'davi_code',
        facebook: 'davi.garcez',
        linkedin: 'davi-cicero-garcez',
        instagram: 'davi.dev',
      },
    },
    availabilityStatus: 'offline',
    email: 'davi.garcez@responza.com.br',
    id: 20,
    name: 'Davi Cicero Garcez',
    phoneNumber: '+5531987654323',
    identifier: null,
    thumbnail: '',
    customAttributes: {
      textContact: 'Vamos colaborar!',
      checkboxContact: true,
    },
    lastActivityAt: 1712123233,
    createdAt: 1712123233,
  },
  {
    additionalAttributes: {
      city: 'Porto Alegre',
      country: 'Brasil',
      description: 'Desenvolvedor backend especializado em APIs robustas e microsserviços.',
      companyName: 'InovaTech Brasil',
      countryCode: 'BR',
      socialProfiles: {
        github: 'oliver-alves',
        twitter: 'oliver_dev',
        facebook: 'oliver.alves',
        linkedin: 'oliver-alves-dev',
        instagram: 'oliver.tech',
      },
    },
    availabilityStatus: 'offline',
    email: 'oliver.alves@responza.com.br',
    id: 19,
    name: 'Oliver Alves',
    phoneNumber: '+5551987654324',
    identifier: null,
    thumbnail: '',
    customAttributes: {
      textContact: 'Vamos agendar uma chamada.',
    },
    lastActivityAt: 1712123232,
    createdAt: 1712123232,
  },
  {
    additionalAttributes: {
      city: 'Salvador',
      country: 'Brasil',
      description: 'Especialista em marketing e criadora de conteúdo.',
      companyName: 'Conteúdo Digital',
      countryCode: 'BR',
      socialProfiles: {
        github: 'julia-mendes',
        twitter: 'julia_content',
        facebook: 'julia.mendes',
        linkedin: 'julia-mendes-marketing',
        instagram: 'julia.cria',
      },
    },
    availabilityStatus: 'offline',
    email: 'julia.mendes@responza.com.br',
    id: 18,
    name: 'Julia Mendes',
    phoneNumber: '+5571987654325',
    identifier: null,
    thumbnail: '',
    customAttributes: {},
    lastActivityAt: 1712123232,
    createdAt: 1712123232,
  },
  {
    additionalAttributes: {
      city: 'Curitiba',
      country: 'Brasil',
      description: 'Especialista em SEO e entusiasta de análises.',
      companyName: 'OptiSearch Brasil',
      countryCode: 'BR',
      socialProfiles: {
        github: 'rafael-almeida',
        twitter: 'rafael_seo',
        facebook: 'rafael.almeida',
        linkedin: 'rafael-almeida-seo',
        instagram: 'rafael.otimiza',
      },
    },
    availabilityStatus: 'offline',
    email: 'rafael.almeida@responza.com.br',
    id: 17,
    name: 'Rafael Almeida',
    phoneNumber: '+5541987654326',
    identifier: null,
    thumbnail: '',
    customAttributes: {},
    lastActivityAt: 1712123232,
    createdAt: 1712123232,
  },
  {
    additionalAttributes: {
      city: 'Brasília',
      country: 'Brasil',
      description: 'Designer UI/UX com talento para designs minimalistas.',
      companyName: 'Design Minimalista',
      countryCode: 'BR',
      socialProfiles: {
        github: 'carolina-ferreira',
        twitter: 'carol_ux',
        facebook: 'carolina.ferreira',
        linkedin: 'carolina-ferreira-ux',
        instagram: 'carol.designs',
      },
    },
    availabilityStatus: 'offline',
    email: 'carolina.ferreira@responza.com.br',
    id: 16,
    name: 'Carolina Ferreira',
    phoneNumber: '+5561987654327',
    identifier: null,
    thumbnail: '',
    customAttributes: {},
    lastActivityAt: 1712123232,
    createdAt: 1712123232,
  },
  {
    additionalAttributes: {
      city: 'Fortaleza',
      country: 'Brasil',
      description: 'Empreendedor com experiência em e-commerce.',
      companyName: 'Ecom Solutions Brasil',
      countryCode: 'BR',
      socialProfiles: {
        github: 'lucas-rodrigues',
        twitter: 'lucas_empreende',
        facebook: 'lucas.rodrigues',
        linkedin: 'lucas-rodrigues-ecom',
        instagram: 'lucas.ecom',
      },
    },
    availabilityStatus: 'offline',
    email: 'lucas.rodrigues@responza.com.br',
    id: 15,
    name: 'Lucas Rodrigues',
    phoneNumber: '+5585987654328',
    identifier: null,
    thumbnail: '',
    customAttributes: {},
    lastActivityAt: 1712123232,
    createdAt: 1712123232,
  },
];
